export function capitalizeFirstLetter(str: any): string {
  if(typeof str != "string") return str?.name
  return str.charAt(0).toUpperCase() + str.slice(1);
}
